import { ADD_SALARY, ADD_SALARY_FAILED, ADD_SALARY_REVISION, ADD_SALARY_REVISION_FAILED, ADD_SALARY_REVISION_SUCCESS, ADD_SALARY_SUCCESS, SALARY, SALARY_FAILED, SALARY_HISTORY, SALARY_HISTORY_FAILED, SALARY_HISTORY_SUCCESS, SALARY_SLIP, SALARY_SLIP_FAILED, SALARY_SLIP_SUCCESS, SALARY_SUCCESS, UPDATE_SALARY, UPDATE_SALARY_FAILED, UPDATE_SALARY_SLIP, UPDATE_SALARY_SLIP_FAILED, UPDATE_SALARY_SLIP_SUCCESS, UPDATE_SALARY_SUCCESS } from "./actionTypes"

let initialState = {
    salary: [],
    salarySlip: [],
    addSalary: "",
    updateSalary: "",
    updateSalarySlip: "",
    salaryHistory: [],
    addSalaryRevision: "",
    loading: false,
    success: false,
    error: ''
}

export const salaryReducer = (state = initialState, action) => {
    switch (action.type) {

        case SALARY: return {
            ...state,
            loading: true,
            success: false,
            error: ''
        }
        case SALARY_SUCCESS: return {
            ...state,
            salary: action.payload,
            loading: false,
            success: true
        }
        case SALARY_FAILED: return {
            ...state,
            loading: false,
            success: false,
            error: action.payload
        }
        case ADD_SALARY: return {
            ...state,
            loading: true,
            success: false,
            error: ''
        }
        case ADD_SALARY_SUCCESS: return {
            ...state,
            addSalary: action.payload,
            salary: [...state.salary, action.payload],
            loading: false,
            success: true,
            error: ''
        }
        case ADD_SALARY_FAILED: return {
            ...state,
            addSalary: [],
            loading: false,
            success: false,
            error: action.payload
        }
        case UPDATE_SALARY: return {
            ...state,
            loading: true,
            success: false,
            error: ''
        }
        case UPDATE_SALARY_SUCCESS: return {
            ...state,
            updateSalary: action.payload,
            salary: state.salary.map((item) => item.id === action.payload.id ? action.payload : item),
            loading: false,
            success: true,
            error: ''
        }
        case UPDATE_SALARY_FAILED: return {
            ...state,
            updateSalary: [],
            loading: false,
            success: false,
            error: action.payload
        }

        case SALARY_SLIP: return {
            ...state,
            loading: true,
            success: false,
            error: ''
        }
        case SALARY_SLIP_SUCCESS: return {
            ...state,
            salarySlip: action.payload,
            loading: false,
            success: true
        }
        case SALARY_SLIP_FAILED: return {
            ...state,
            loading: false,
            success: false,
            error: action.payload
        }
        case UPDATE_SALARY_SLIP: return {
            ...state,
            loading: true,
            success: false,
            error: ''
        }
        case UPDATE_SALARY_SLIP_SUCCESS: return {
            ...state,
            updateSalarySlip: action.payload,
            salarySlip: state.salarySlip.map((item) => item.id === action.payload.id ? action.payload : item),
            loading: false,
            success: true,
            error: ''
        }
        case UPDATE_SALARY_SLIP_FAILED: return {
            ...state,
            updateSalarySlip: "",
            loading: false,
            success: false,
            error: action.payload
        }

        case SALARY_HISTORY: return {
            ...state,
            loading: true,
            success: false,
            error: ''
        }
        case SALARY_HISTORY_SUCCESS: return {
            ...state,
            salaryHistory: action.payload,
            loading: false,
            success: true
        }
        case SALARY_HISTORY_FAILED: return {
            ...state,
            loading: false,
            success: false,
            error: action.payload
        }
        case ADD_SALARY_REVISION: return {
            ...state,
            loading: true,
            success: false,
            error: ''
        }
        case ADD_SALARY_REVISION_SUCCESS: return {
            ...state,
            addSalaryRevision: action.payload,
            salaryHistory: [...state.salaryHistory, action.payload],
            loading: false,
            success: true,
            error: ''
        }
        case ADD_SALARY_REVISION_FAILED: return {
            ...state,
            addSalaryRevision: [],
            loading: false,
            success: false,
            error: action.payload
        }
        default: return state
    }
}